<template>
  <div>
    <v-row class="primary-pattern"></v-row>
    <v-col
      cols="12"
      sm="12"
      md="12"
      lg="10"
      xl="8"
      offset-lg="1"
      offset-xl="2"
      style="margin-top: -50vh;"
    >
      <v-sheet
        elevation="3"
        :class="[$vuetify.breakpoint.smAndUp ? 'mx-12 mb-12' : '']"
        style="margin-top: 140px;"
      >
        <v-row :class="[$vuetify.breakpoint.mdAndUp ? 'px-12' : 'mx-0 px-5']">
          <v-col cols="12" sm="12" md="6" lg="5" class="pt-12 pb-6">
            <h1 class="display-1 text-uppercase pb-5">Artículos y eventos</h1>
            <v-list three-line style="height: 60vh; overflow-y: scroll;">
              <template v-for="(item, index) in articles">
                <v-list-item :key="index" @click="selected = item">
                  <v-list-item-avatar v-if="item.picture != null" tile size="100">
                    <v-img :src="publicPath+item.picture"></v-img>
                  </v-list-item-avatar>
                  <v-list-item-avatar v-else tile size="100">No hay imagen</v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title class="title text-uppercase">
                      {{
                      item.title
                      }}
                    </v-list-item-title>
                    <v-list-item-subtitle v-html="item.description"></v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </template>
            </v-list>
          </v-col>
          <v-col cols="12" sm="12" md="6" lg="7" class="pt-12 pb-6 px-5" v-if="selected != null">
            <img :src="publicPath + selected.picture"
              v-if="selected.picture != null"
              height="auto"
              width="100%"
            >
            <img
              src="https://via.placeholder.com/1024x720.png?text=No+hay+imagen"
              height="auto"
              width="100%"
              v-else
            ></img>
            <h1 class="display-1 font-weight-bold text-uppercase pt-5">{{ selected.title }}</h1>
            <h4
              class="title text-uppercase font-weight-light font-italic py-2"
            >{{ selected.subtitle }}</h4>
            <p align="justify" class="body-1" v-html="selected.description"></p>
            <div align="center" v-if="selected.file!=null">
              <a :href="'https://adminuva.tidingo.com'+selected.file" target="_blank">Ver más información</a>
            </div>            
            <v-btn style="background-color: rgb(59, 89, 152);border-color: rgb(59, 89, 152);" class="white--text" @click="shareEvent()">
              <v-icon class="mr-2">mdi-facebook</v-icon> Compartir
            </v-btn>
          </v-col>
        </v-row>
      </v-sheet>
    </v-col>
  </div>
</template>
<style scoped>
.primary-pattern {
  height: 60vh;
  background-image: url("/imagenes/fondo-desenfoque-min.jpg");
  background-repeat: repeat;
  background-repeat: no-repeat;
}
.pt-header {
  padding-top: 120px;
}
ul {
  list-style: none;
}
/* width */
::-webkit-scrollbar {
  width: 5px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #2f4084;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #141c3e;
}
</style>
<script>
import { mapState } from "vuex";
import { mask } from "vue-the-mask";
import axios from "axios";
import lodash from "lodash";
export default {
  mounted() {
    this.sendInfoData();
  },
  data: () => ({
    publicPath: "https://adminuva.tidingo.com/",
    selected: null,
    articles: [],
  }),
  computed: {
    ...mapState({
      campus: (state) => state.cities.campus,
      city_options: (state) => state.cities.city_options,
      city_selected: (state) => state.cities.city_selected,
      cities: (state) => state.cities.cities,
      vida: (state) => state.cities.vida,
      link_location: (state) => state.cities.link_location,
      link_information: (state) => state.cities.link_information,
    }),
    shareLink() {
      return (
        "https://www.facebook.com/sharer.php?u=https%3A%2F%2Fwww.colegio.uva.edu.mx%2F" +
        this.city_options.link +
        "%2Feventos"
      );
    },
  },
  watch: {
    city_options() {
      this.sendInfoData();
    },
  },
  methods: {
    replaceAll(string, search, replace) {
      return string.split(search).join(replace);
    },
    insertYoutubePlayer(text) {
      var urlRegex =
        /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gi;
      return text.replace(urlRegex, function (url) {
        return (
          '</br><iframe width="100%" height="315" src="' +
          url +
          '" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>'
        );
      });
    },
    sendInfoData() {
      var self = this;
      var url =
        "https://adminuva.tidingo.com/api/events-list-by-campus?webpage=Colegio&campus=";
      var cselected = self.city_options.name;
      axios({
        method: "get",
        url: url + cselected,
        config: {
          headers: {
            "Access-Control-Allow-Origin": "*",
            "Content-Type": "application/json",
          },
          withCredentials: true,
          credentials: "same-origin",
        },
      })
        .then(function (response) {
          if (response.data.data.length > 0) {
            let art = response.data.data;
            art.map((item) => {
              let des = self.replaceAll(item.description, "!*", "<strong>");
              des = self.replaceAll(des, "*!", "</strong>");
              des = self.replaceAll(des, "!_", "<i>");
              des = self.replaceAll(des, "_!", "</i>");
              des = self.replaceAll(des, "Link:", "");
              des = self.replaceAll(des, /\n/gi, "</br>");
              des = self.replaceAll(
                des,
                "https://youtu.be/",
                "https://www.youtube.com/embed/"
              );
              des = self.insertYoutubePlayer(des);
              item.description = des;
              return item;
            });
            self.articles = art;
            self.selected = self.articles[0];
          }
        })
        .catch(function (error) {});
    },
    shareEvent() {
      var element = document.createElement("a");
      element.setAttribute("href", this.shareLink);
      element.innerHTML = "";
      element.setAttribute("target", "_blank"); //Si se quiere abrir el documento en otra pestaña: descomentar esta línea y comentar la línea de arriba
      element.click();
    },
  },
};
</script>
